import { Component, Input, OnInit } from '@angular/core';
import { InputDisplay } from '../input-group/input-group.properties';
import { ToggleSwitchComponent } from '../toggle-switch/toggle-switch.component';

@Component({
  selector: 'shared-ui-inputs-toggle-switch-group',
  templateUrl: './toggle-switch-group.component.html',
  styleUrl: './toggle-switch-group.component.css',
  standalone: false,
})
export class ToggleSwitchGroupComponent extends ToggleSwitchComponent implements OnInit {
  @Input() display = InputDisplay.InlineSpaced;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  isInline(): boolean {
    return this.display === InputDisplay.Inline || this.isJustified() || this.isReversed();
  }

  isInlineOnly(): boolean {
    return this.display === InputDisplay.Inline;
  }

  isJustified(): boolean {
    return this.display === InputDisplay.InlineSpaced;
  }

  isReversed(): boolean {
    return this.display === InputDisplay.InlineReversed;
  }
}
